$.fn.PicturePlus_Item = function(picture) {
  let self = this

  if (self.data('picture-plus-item')) {
    return self.data('picture-plus-item')
  }

  self.ratio = function() {
    return 16 / parseFloat($('body').css('font-size'))
  }

  self.button = self.find('.picture-plus-item__toggle-btn')
  self.close_button = self.find('.picture-plus-item__close-btn')
  self.bubble = self.find('.picture-plus-item__bubble')
  self.bubble_path = self.find('path')
  self.bubble_offset = 0
  self.wrapper = self.find('.picture-plus-item__content')
  self.content = self.find('.picture-plus-item__content > div')
  self.expanded = false

  self.resized = function() {
    let contentHeight = (self.wrapper.outerHeight(false) - 24) * self.ratio(),
    x1 = Math.round(190 - (self.bubble_offset * self.ratio()) - 3),
    x2 = Math.round(190 + (self.bubble_offset * self.ratio()) + 3)
    if (!self.bubble_offset) {
      x1 = 190
      x2 = 190
    }
    self.bubble_path.attr('d', 'M9.6 26.3h' + x1 + 'l18.5-20.1 17.5 20.1h' + x2 + '.7v' + contentHeight + '.5H9.6V26.3z')
  }

  self.open = function() {
    self.expanded = true
    if (!$.mlmi.mobile.isMobile) {
      self.append(self.bubble)
      self.bubble_offset = 0
      self.bubble.css('transform', '')
      if (self.bubble.offset().left < $('.news').offset().left + (24 * self.ratio())) {
        self.bubble_offset = Math.round(($('.news').offset().left + (24 * self.ratio())) - self.bubble.offset().left)
        self.bubble.css('transform', 'translateX(' + self.bubble_offset + 'px)')
      }
      self.resized()
      $(window).off('click', self.click_outside).on('click', self.click_outside)
      self.css('z-index', 2)
      self.closest('.accordion__panel').css({
        height: self.closest('.accordion__panel').height() + 'px',
        overflow: 'visible',
      })
    }
    self.button.attr('aria-expanded', 'true')
    self.bubble.attr('aria-hidden', 'false')
  }

  self.close = function() {
    self.expanded = false
    self.button.attr('aria-expanded', 'false')
    self.bubble.attr('aria-hidden', 'true')
    $(window).off('click', self.click_outside)
    self.css('z-index', '')
    self.closest('.accordion__panel').css({
      height: '',
      overflow: '',
    })
  }

  self.click_outside = function(e) {
    if (!$(e.target).hasClass('picture-plus-item') && (!$(e.target).closest('.picture-plus-item').length || !$(e.target).closest('.picture-plus-item').is(self))) {
      self.close()
      e.preventDefault()
      e.stopPropagation()
    }
  }

  self.toggled = function() {
    if (self.expanded) {
      self.close()
    } else {
      self.open()
    }
  }

  return function() {
    $(window).on('load resize orientationchange', self.resized)
    self.resized()
    self.close_button.on('click', self.close)
    self.button.on('click', self.toggled)
    self.data('picture-plus-item', self)
    return self
  }()
}

$.fn.PicturePlus = function() {
  let self = this

  if (self.data('picture-plus')) {
    return self.data('picture-plus')
  }

  self.items = []

  return function() {
    self.find('.picture-plus__item').each(function() {
      self.items.push($(this).PicturePlus_Item(self))
    })
    // self.on('click', function(e) {
    //   let x = Math.round(((e.clientX - self.offset().left) / self.width()) * 1000) / 10,
    //   y = Math.round(((e.clientY - self.offset().top) / self.height()) * 1000) / 10
    //   console.log('left: ' + x + '%; top: ' + y + '%;')
    // })
    self.data('picture-plus', self)
    return self
  }()
}
